const initialState = {
  data: null,
  loading: null,
  filters: {
    integration_id: '',
  },
};

export default initialState;
